// extracted by mini-css-extract-plugin
export var errorIcon = "_ml-1";
export var nameLogo = "_ml-0";